import React from "react";
import { ColorRing,ThreeDots } from "react-loader-spinner";

function SmallLoader() {
  return (
    // <ColorRing
    //   visible={true}
    //   height="80"
    //   width="80"
    //   strokeWidth="1"
    //   ariaLabel="blocks-loading"
    //   wrapperStyle={{}}
    //   wrapperClass="blocks-wrapper"
    //   colors={Array(5).fill("#1c74d0")}
    // />
    <ThreeDots
      height="22"
      width="22"
      radius="9"
      color="#1c74d0"
      ariaLabel="three-dots-loading"
      wrapperStyle={{}}
      wrapperClassName=""
      visible={true}
    />
  );
}

export default SmallLoader;
